<div class="wrap">
  <button (click)="navigateToPreference()">Email Preference</button> <br>
  <button (click)="navigateToContact()">Contact</button>
</div>


